export default "__VITE_ASSET__df16a205__"